/** Funcionalidades controladas pelo papel na lista (FuncionalidadeLista na API). */
export type FuncionalidadeLista =
  | 'LISTA_EDITAR'
  | 'LISTA_FASES'
  | 'LISTA_EQUIPE'
  | 'LISTA_SHAPES'
  | 'TAXON_CADASTRAR'
  | 'TAXON_EDITAR'
  | 'TAXON_EXCLUIR'
  | 'IMPORTACAO_IMPORTAR'
  | 'IMPORTACAO_EXCLUIR'
  | 'IMPORTACAO_MIGRAR'
  | 'FICHA_EDITAR'
  | 'FICHA_EDITAR_DISTRIBUICAO_POPULACAO'
  | 'OCORRENCIA_EDITAR'
  | 'OCORRENCIA_SELECIONAR'
  | 'MAPA_CALCULAR'
  | 'MAPA_CAMADAS'
  | 'MULTIMIDIA_EDITAR'
  | 'DOCUMENTO_ANEXAR'
  | 'DOCUMENTO_EXCLUIR_TODOS'
  | 'AVALIACAO_CRIAR'
  | 'AVALIACAO_CRITERIOS'
  | 'AVALIACAO_EXCLUIR'
  | 'FICHA_ENVIAR_AVALIACAO'
  | 'AVALIACAO_ENVIAR_REVISAO'
  | 'REVISAO_REGISTRAR'
  | 'REVISAO_CONCLUIR'
  | 'VALIDACAO_REGISTRAR'
  | 'VALIDACAO_CONCLUIR'
  | 'AVALIACAO_CONCLUIR'
  | 'AVALIACAO_ENCERRAR'

/** Funcionalidades que dão acesso às telas de importação e de interoperabilidade (SALVE). */
export const FUNCIONALIDADES_IMPORTACAO: FuncionalidadeLista[] = [
  'IMPORTACAO_IMPORTAR',
  'IMPORTACAO_EXCLUIR',
  'IMPORTACAO_MIGRAR',
]

export interface MinhasPermissoesDto {
  listaId: number
  /** Nome do papel em TipoUsuarioListas, ou ADMINISTRADOR DO SISTEMA; nulo se a pessoa não está na lista. */
  papel: string | null
  administradorSistema: boolean
  funcionalidades: FuncionalidadeLista[]
  /** Papel técnico fora do período das suas fases: nenhuma alteração é permitida agora. */
  foraDoPeriodo: boolean
  /** Fases e datas em que o papel altera dados (preenchida quando foraDoPeriodo). */
  mensagemPeriodo: string | null
  /** Funcionalidades do papel sem o bloqueio de fase: decidem que áreas a pessoa vê. */
  funcionalidadesDoPapel?: FuncionalidadeLista[]
}

export interface MatrizPermissoesDto {
  papeis: { id: number; nome: string; descricao: string }[]
  funcionalidades: { funcaoId: number; codigo: FuncionalidadeLista; nome: string; descricao: string; modulo: string }[]
  permissoes: MatrizPermissaoItem[]
}

export interface MatrizPermissaoItem {
  funcaoId: number
  tipoUsuarioListaId: number
}

const ROTULOS_PAPEL: Record<string, string> = {
  'ADMINISTRADOR DO SISTEMA': 'Administrador do sistema',
  ADMINISTRADOR: 'Administrador da lista',
  COORDENADOR: 'Coordenador',
  AVALIADOR: 'Avaliador',
  'ANALISTA TÉCNICO': 'Analista técnico',
  VALIDADOR: 'Validador',
  REVISOR: 'Revisor',
  'GRUPO AVALIADOR': 'Grupo avaliador',
  'GRUPO VALIDADOR': 'Grupo validador',
}

export function rotuloPapel(papel: string | null | undefined): string {
  if (!papel) return 'Sem papel nesta lista'
  return ROTULOS_PAPEL[papel] ?? papel
}
